import { Button, Flex } from '@applyboard/crystal-ui'
import {
  ApplicationDetailCardAcceptDialog,
  ApplicationDetailCardAcceptDialogProps,
} from './ApplicationDetailCardAcceptDialog'
import {
  ApplicationDetailCardRejectDialog,
  ApplicationDetailCardRejectDialogProps,
} from './ApplicationDetailCardRejectDialog'

type ApplicationDetailCardActionsProps = Readonly<{
  onOfferConditionsClick?: () => void
  acceptDialog?: ApplicationDetailCardAcceptDialogProps
  rejectDialog?: ApplicationDetailCardRejectDialogProps
  loading?: boolean
}>

export function ApplicationDetailCardActions(props: ApplicationDetailCardActionsProps) {
  return (
    <>
      {props.acceptDialog && props.rejectDialog ? (
        <Flex gap={2}>
          <Flex.Item basis="50%">
            <ApplicationDetailCardAcceptDialog
              programName={props.acceptDialog.programName}
              campusName={props.acceptDialog.campusName}
              intakeTermName={props.acceptDialog.intakeTermName}
              onSubmit={props.acceptDialog.onSubmit}
              loading={props.loading}
            />
          </Flex.Item>
          <Flex.Item basis="50%">
            <ApplicationDetailCardRejectDialog
              onSubmit={props.rejectDialog.onSubmit}
              loading={props.loading}
            />
          </Flex.Item>
        </Flex>
      ) : null}
      {props.onOfferConditionsClick ? (
        <Flex>
          <Button
            intent="primary"
            emphasis="outlined"
            width="fill"
            onClick={props.onOfferConditionsClick}
            disabled={props.loading}
          >
            Offer Conditions
          </Button>
        </Flex>
      ) : null}
    </>
  )
}
